module.exports = __webpack_public_path__ + "img/HQ-PA2W1S_ALL.5ba5da93.jpg";